// Just doing this as a sort of mindless Promise based
// approach: function returns a promise that will return FB
// after it has inited.
let inited = false;

window.fbAsyncInit = () => {
  FB.init({
    appId: process.env.VUE_APP_FACEBOOK_APP_ID,
    xfbml: true,
    version: process.env.VUE_APP_FACEBOOK_API_VERSION,
  });
  inited = true;
};

(function(d, s, id) {
  let js,
    fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) {
    return;
  }
  js = d.createElement(s);
  js.id = id;
  js.src = "//connect.facebook.net/en_US/sdk.js";
  fjs.parentNode.insertBefore(js, fjs);
})(document, "script", "facebook-jssdk");

export default () => {
  return new Promise((resolve, reject) => {
    if (inited) {
      resolve(FB);
    } else {
      let tries = 0;
      // setup a checker that looks to see if the
      // facebook stuff has initialized yet and if
      // not, try again every 100ms until 30 seconds
      // has passed.
      const intervalId = setInterval(() => {
        if (inited) {
          // it has initialized now, clean up checking and
          // return back the facebook object
          clearInterval(intervalId);
          resolve(FB);
        } else {
          tries++;
        }
        // if it doesn't connect in 30 seconds then we've got a problem
        if (tries > 300) {
          clearInterval(intervalId);
          reject("Unable to connect to Facebook");
        }
      }, 100);
    }
  });
};
